import clsx from 'clsx';
import React from 'react';

type Props = {
  children?: React.ReactNode;
  variant?: 'default' | 'flat';
  classes?: string;
};

const Tabs = ({ children, variant = 'default', classes }: Props) => {
  const childrenCount = React.Children.toArray(children).length;

  return (
    <div
      role="tablist"
      className={clsx(
        'mb-32 mt-16 flex justify-around rounded-28 bg-primary-surface-high p-4 sm:flex-row sm:rounded-full',
        classes,
        {
          'pb-32': variant === 'flat',
          'flex-col': childrenCount > 3
        }
      )}
    >
      {children}
    </div>
  );
};
export default Tabs;
